import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import classNames from 'classnames'
import { Row, Col } from 'antd'
import { Controller, useWatch } from 'react-hook-form'

import { formatErrorMessage } from 'helpers/contactRequestForm'
import { combineDateAndTime, choosableTimes } from 'helpers/date'

import AntDropdown from 'components/AntDropdown'
import FormattedMessage from 'components/FormattedMessage'
import FormItem from 'components/Form/Item'

import './index.less'

const EventTimes = (props) => {
  const {
    disabled,
    intl,
    initialStartTime,
    initialEndTime,
    rowProps,
    labelPostfix,
    size,
    hideErrors,
  } = props

  const timesStartsAt = useWatch({ name: 'timesStartsAt', defaultValue: initialStartTime })
  const timesEndsAt = useWatch({ name: 'timesEndsAt', defaultValue: initialEndTime })

  const timeRangeValidator = () => {
    const currentDate = new Date()
    const startTime = combineDateAndTime(currentDate, timesStartsAt)
    const endTime = combineDateAndTime(currentDate, timesEndsAt)

    if (startTime.isSameOrAfter(endTime)) {
      return intl.formatMessage({ id: 'eventTimes.errors.startTimeAfterEndTime' })
    }

    return true
  }

  return (
    <Row {...rowProps}>
      <Col span={12}>
        <FormItem
          name="timesStartsAt"
          label={<><FormattedMessage id="eventTimes.timesStartsAt" />{labelPostfix}</>}
          className={classNames('times-range__starts-at', { 'times-range__hide-errors': hideErrors })}
        >
          <Controller
            name="timesStartsAt"
            defaultValue={initialStartTime}
            rules={{
              deps: ['timesStartsAt', 'timesEndsAt'],
              required: formatErrorMessage(intl, 'timesStartsAt'),
              validate: {
                timeRangeValidator,
              },
            }}
            render={({
              field: { onChange, onBlur, value, name, ref },
            }) => (
              <AntDropdown
                ref={ref}
                size={size}
                disabled={disabled}
                segments={[
                  {
                    name: 'timesStartsAt',
                    options: choosableTimes,
                    currentValue: value,
                  },
                ]}
                useNativeSelectOnMobile={true}
                onChange={(values) => onChange(values.timesStartsAt)}
                onBlur={onBlur}
              />
            )}
          />
        </FormItem>
      </Col>

      <Col span={12}>
        <FormItem
          name="timesEndsAt"
          label={<><FormattedMessage id="eventTimes.timesEndsAt" />{labelPostfix}</>}
          className={classNames('times-range__ends-at', { 'times-range__hide-errors': hideErrors })}
        >
          <Controller
            name="timesEndsAt"
            defaultValue={initialEndTime}
            rules={{
              deps: ['timesStartsAt', 'timesEndsAt'],
              required: formatErrorMessage(intl, 'timesStartsAt'),
              validate: {
                timeRangeValidator,
              },
            }}
            render={({
              field: { onChange, onBlur, value, name, ref },
            }) => (
              <AntDropdown
                ref={ref}
                size={size}
                disabled={disabled}
                segments={[
                  {
                    name: 'timesEndsAt',
                    options: choosableTimes,
                    currentValue: value,
                  },
                ]}
                useNativeSelectOnMobile={true}
                onChange={(values) => onChange(values.timesEndsAt)}
                onBlur={onBlur}
              />
            )}
          />
        </FormItem>
      </Col>
    </Row>
  )
}

EventTimes.propTypes = {
  disabled: PropTypes.bool,
  hideErrors: PropTypes.bool,
  initialEndTime: PropTypes.string,
  initialStartTime: PropTypes.string,
  intl: PropTypes.object.isRequired,
  labelPostfix: PropTypes.string,
  rowProps: PropTypes.object,
  size: PropTypes.string,
}

export default injectIntl(EventTimes)
